
export const LOGIN_MESSAGE_LOCATION = 'loginMessage'

export const getCookieUsername = () => {
  return getCookie('user')
}

export const getCookie = (cname, stripQuotation = true) => {
  const name = cname + "="
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      const ret = c.substring(name.length, c.length)
      return (stripQuotation) ? ret.replace(/["']+/g, '') : ret
    }
  }
  return ""
}

export const deleteCookie = (c_name) => {
  window.document.cookie = encodeURIComponent(c_name) + "=deleted; expires=" + new Date(0).toUTCString()
}

export const getParam = (name) => {
  let result, tmp
  location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
      tmp = item.split("=")
      if (tmp[0] === name) result = decodeURIComponent(tmp[1])
    })
  return result
}

export const getParams = () => location.search.substr(1).split("&").reduce((cum, item) => {
  const pair = item.split("=")
  return {...cum, [pair[0]]: pair[1] }
}, {})

export const KEYCODE_LEFT_ARROW = 37
export const KEYCODE_UP_ARROW = 38
export const KEYCODE_RIGHT_ARROW = 39
export const KEYCODE_DOWN_ARROW = 40

export const IS_FIREFOX = (() => navigator.userAgent.toLowerCase().indexOf('firefox') > -1)()
export const IS_LEGACY_EDGE = (() => navigator.userAgent.toLowerCase().indexOf('edge') > -1)()
export const IS_IOS = (() => !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform))()
export const IS_IPHONE = (() => !!navigator.platform && /iPhone|iPod/.test(navigator.platform))()
export const IS_ANDROID_PHONE = (() => !!navigator.appVersion && /android/.test(navigator.appVersion.toLowerCase()) && window.innerWidth < 1024)()
export const IS_PHONE = IS_IPHONE || IS_ANDROID_PHONE
export const IS_UNSUPPORTED = IS_IPHONE || IS_ANDROID_PHONE
